














































































































































































import { Component, Vue, Watch, Prop, Mixins } from 'vue-property-decorator';
import VehicleService from '@/services/vehicle.service';
import VehicleDetail, {
  VehicleModelDetail,
  YearModel,
} from '@/models/VehicleDetail';
import BaseServiceMixin from '@/mixins/base.service.mixin';
import { KeyValuePair } from '@/models/KeyValuePair';
import { getBearerToken } from '@/services/base.service';
import StoreVuexModule from '@/stores/StoreVuexModule';
import { getModule } from 'vuex-module-decorators';
import eventBus from '@/common/bus';

@Component({
  name: 'ManualSearch',
})
export default class ManualSearch extends Mixins(BaseServiceMixin) {
  private get form() {
    return this.$refs.vehicleForm as any;
  }
  @Prop({
    default: () => new VehicleDetail(),
  })
  public value!: VehicleDetail;
  protected loading = {
    make: true,
    modelGroup: false,
    model: false,
    year: false,
    seats: false,
    transmission: false,
  };
  private store = getModule(StoreVuexModule, this.$store);
  private selected: VehicleDetail = new VehicleDetail();
  private makes: Array<KeyValuePair<number, string>> = [];
  private modelGroups: Array<KeyValuePair<number, string>> = [];
  private models: VehicleModelDetail[] = [];
  private years: YearModel[] = [];
  private seats: number[] = [];
  private transmissions: Array<KeyValuePair<number, string>> = [];

  private vehicleService!: VehicleService;

  public created() {
    this.vehicleService = new VehicleService(this.axiosInstance);
  }

  @Watch('value', { deep: true })
  protected updateInternalStore() {
    this.selected = Object.assign({}, this.value);
    if (this.selected.regNo) {
      this.selected = new VehicleDetail();
    }
    if (Object.keys(this.selected).length === 0) {
      this.reset('make');
    }
  }

  private reset(key: string | null = null) {
    if (key === 'make') {
      this.resetModelGroup();
      this.resetModel();
      this.resetYear();
    }

    if (key === 'modelGroup') {
      this.resetModel();
      this.resetYear();
    }

    if (key === 'model') {
      this.resetYear();
    }

    this.resetSeatTransmission();

    this.form.resetValidation();
  }

  private validate(name: string) {
    return [(v: string) => !!v || name + ' is required'];
  }

  private async searchVehicle() {
    if (this.form.validate()) {
      // no auth needed here, but is required in the next step and we want a user id to track with segments
      const token = await getBearerToken('ManualSearch');

      if (token !== '') {
        eventBus.$emit('track', 'SearchVehicle', {
          type: 'Manual',
          vehicleFound: true,
          vehicleDetails: {
            makeId: this.selected.makeId,
            make: this.selected.make,
            modelGroupId: this.selected.modelGroupId,
            modelGroup: this.selected.modelGroup,
            modelId: this.selected.modelId,
            model: this.selected.model,
            year: this.selected.yearModel,
            seatCount: this.selected.seats,
            transmissionId: this.selected.transmissionId,
            transmission: this.selected.transmission,
          },
        });
        delete this.selected.regNo;
        this.$emit('input', this.selected);
      }
    }
  }

  private mounted() {
    this.updateInternalStore();
    this.getMakes();
  }

  private async getMakes() {
    this.$set(this.loading, 'make', true);
    try {
      const makes = await this.vehicleService.GetMakes(this.store.apiKey);
      if (makes) {
        this.makes = makes;
      }
      const make = this.autoSelect('make', this.makes);
      if (make) {
        this.onMakeChange(make);
      }
    } catch (error) {
      // error
    }
    this.$set(this.loading, 'make', false);
  }

  private async onMakeChange(makeId: number) {
    this.reset('make');
    const make = this.makes.find((x) => x.key === makeId);
    if (make) {
      this.selected.make = make.value;
    }
    this.$set(this.loading, 'modelGroup', true);
    try {
      const modelGroups = await this.vehicleService.GetModelGroups(
        this.selected,
      );
      if (modelGroups) {
        this.modelGroups = modelGroups;
      }
      const modelGroup = this.autoSelect('modelGroup', this.modelGroups);
      if (modelGroup) {
        this.onModelGroupChange(modelGroup);
      }
    } catch (error) {
      // error
    }
    this.$set(this.loading, 'modelGroup', false);
  }

  private async onModelGroupChange(modelGroupId: number) {
    this.reset('modelGroup');
    const modelGroup = this.modelGroups.find((x) => x.key === modelGroupId);
    if (modelGroup) {
      this.selected.modelGroup = modelGroup.value;
    }
    this.$set(this.loading, 'model', true);
    try {
      this.models = (await this.vehicleService.GetModels(this.selected)) || [];
      this.models = this.models.reduce(
        (p, c) => {
          if (!p.find((i) => i.name === c.name)) {
            p.push(c);
          }

          return p;
        },
        [] as VehicleModelDetail[],
      );
      const model = this.autoSelectId('modelId', this.models);
      if (model) {
        this.onModelChange(model.id);
      }
    } catch (error) {
      // error
    }
    this.$set(this.loading, 'model', false);
  }

  private async onModelChange(modelId: number) {
    this.reset('model');

    const model = this.models.find((x) => x.id === modelId);
    if (model) {
      this.selected.model = model.name;
    }

    this.$set(this.loading, 'year', true);
    try {
      const years = await this.vehicleService.GetYears(this.selected);
      if (years) {
        this.years = years;
      }
      const year = this.autoSelect('yearModel', this.years);
      if (year) {
        this.onYearChange();
      }
    } catch (error) {
      // error
    }
    this.$set(this.loading, 'year', false);
  }

  private async onYearChange() {
    this.reset();
    try {
      this.$set(this.loading, 'transmission', true);
      this.$set(this.loading, 'seats', true);
      await this.getSeatTransmissions();
    } catch (error) {
      // error
    }
    this.$set(this.loading, 'seats', false);
    this.$set(this.loading, 'transmission', false);
  }

  private async onTransmissionChange(transmissionId: number) {
    const transmission = this.transmissions.find(
      (x) => x.key === transmissionId,
    );
    if (transmission) {
      this.selected.transmission = transmission.value;
    }
  }

  private async getSeatTransmissions() {
    this.$set(this.loading, 'seats', true);
    const result = await Promise.all([
      this.vehicleService.GetSeats(this.selected),
      this.vehicleService.GetTransmissions(this.selected),
    ]);
    if (result) {
      this.seats = result[0];
      // remove duplicate names
      this.transmissions = result[1].reduce(
        (p, c) => {
          if (!p.find((i) => i.value === c.value)) {
            p.push(c);
          }

          return p;
        },
        [] as Array<KeyValuePair<number, string>>,
      );
      const transmission = this.autoSelectKey(
        'transmissionId',
        this.transmissions,
      );
      if (transmission) {
        this.selected.transmission = transmission.value;
      }
      this.autoSelect('seats', this.seats);
    }
  }

  private resetModelGroup() {
    this.modelGroups = [];
    this.$set(this.selected, 'modelGroup', '');
  }

  private resetModel() {
    this.models = [];
    this.selected.vehicleModel = new VehicleModelDetail();
    this.$set(this.selected, 'model', '');
  }

  private resetYear() {
    this.years = [];
    this.$set(this.selected, 'yearModel', 0);
  }

  private resetSeatTransmission() {
    this.transmissions = [];
    this.$set(this.selected, 'transmission', '');

    if (this.selected.seats) {
      this.seats = [];
      this.$set(this.selected, 'seats', 0);
    }
  }

  private autoSelect(model: string, data: any[]): any {
    if (data && data.length === 1) {
      this.$set(this.selected, `${model}`, data[0]);

      return data[0];
    }
    return null;
  }

  private autoSelectId(model: string, data: any[]): any {
    if (data && data.length === 1) {
      this.$set(this.selected, `${model}`, data[0].id);

      return data[0];
    }
    return null;
  }

  private autoSelectKey(model: string, data: any[]): any {
    if (data && data.length === 1) {
      this.$set(this.selected, `${model}`, data[0].key);

      return data[0];
    }
    return null;
  }
}
